import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useClientIdSelector } from '../../selectors/useClientIdSelector';
import { addOrUpdateBoundaryStatsItems } from '../stats.actionCreators';
import {
  boundaryStatsItemToBoundaryStatsRequestItem, isBoundaryStatItem,
  setStatsItemToLoading,
} from '../stats.helpers';
import { calculateBoundaryStats } from '../stats.repository';
import type {
  BoundaryStatsItem, StatItem,
} from '../stats.state';

export const useManageStats = () => {
  const dispatch = useDispatch();
  const clientId = useClientIdSelector();

  const runCalculateBoundaryStats = useCallback(async (
    boundaryStatsItems: ReadonlyArray<BoundaryStatsItem>,
  ) => {
    if (!clientId) {
      return;
    }

    dispatch(addOrUpdateBoundaryStatsItems(boundaryStatsItems.map(setStatsItemToLoading)));
    await calculateBoundaryStats(clientId, boundaryStatsItems.map(boundaryStatsItemToBoundaryStatsRequestItem));
  }, [clientId, dispatch]);

  const calculateStats = useCallback(async (
    items: ReadonlyArray<StatItem>,
  ) => {
    const boundaryStatsItems = items.filter(isBoundaryStatItem);
    await runCalculateBoundaryStats(boundaryStatsItems);
  }, [runCalculateBoundaryStats]);

  return { calculateStats };
};
